
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2" viewBox="0 0 100 100"><path d="M57.221 24.648c7.321 15.719 26.377 22.286 24.654 42.742-2.029 24.092-19.164 30.145-28.638 30.576-9.474.431-27.561-2.907-32.514-25.623C15.161 46.828 39.456 7.638 53.452 2.039c-.538 6.352.819 16.277 3.769 22.609ZM44.761 89.69c6.407 1.331 11.317 2.256 11.899-.324.877-3.884-14.063-6.075-24.049-7.156 2.997 3.162 9.048 6.835 12.15 7.48Z" style="fill-rule:nonzero"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    